export * from './complete-account'
export * from './contentful'
export * from './forms'
export * from './header'
export * from './images'
export * from './layout'
export * from './outfits'
export * from './persistent-cart'
export * from './productTile'
export * from './social-media'
export {default as Page} from './page'



// WEBPACK FOOTER //
// ./src/modules/index.js